import {
  GET_ORDER,
  GET_ORDERS,
  ORDER_LOADING,
  ORDER_LOADING_END,
  CLEAR_ORDERS_STATE,
  CLEAR_ORDER_STATE,
  CLEAR_ORDER_REDUCER,
} from "../actions/types";
import { getResponsePayload } from "../utils/reducerUtils";

const initialState = {
  order: {},
  orders: [],
  loading: false,
  pagination: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ORDER:
      return {
        ...state,
        order: action.payload,
        loading: false,
      };

    case GET_ORDERS:
      const data = getResponsePayload(action);
      return {
        ...state,
        orders: data.elements,
        loading: false,
        pagination: data.pagination,
      };

    case ORDER_LOADING:
      return {
        ...state,
        loading: true,
      };

    case ORDER_LOADING_END:
      return {
        ...state,
        loading: false,
      };

    case CLEAR_ORDERS_STATE:
      return {
        ...state,
        loading: false,
        order: {},
        orders: [],
      };

    case CLEAR_ORDER_STATE:
      return {
        ...state,
        loading: false,
        order: {},
      };

    case CLEAR_ORDER_REDUCER:
      return {
        ...state,
        loading: false,
        order: {},
        orders: [],
      };

    default:
      return state;
  }
}
